GatorSurvey.app.directive('gsSurveyLiveReview', ['$timeout', '$mdDialog', 'surveyResponseService', 'conditionCheckingService', 'recaptchaService', SurveyLiveReview]);

function SurveyLiveReview($timeout, $mdDialog, surveyResponseService, conditionCheckingService, recaptchaService) {
    return {
        require: '?ngModel',
        restrict: 'AE',
        scope: {
            survey: "=?ngModel"
        },
        templateUrl: 'Assets/Scripts/App/Directives/LiveReview/Templates/SurveyLiveReview.html',
        controller: ('liveSurveyReview', ['$scope', '$q', function($scope, $q) {
                var self = this;
                $scope.loading = true;
                $scope.questions = [];
                $scope.PageStyle = {};
                function buildPageData() {
                    angular.forEach($scope.survey.pages, function (pageItem, value) {
                        angular.forEach(pageItem.elements, function (elmItem, value) {
                            if (elmItem.type === "question") {
                                $scope.questions.push(elmItem);
                            }
                        });
                    });
                }

                $scope.$watch('survey', function () {
                    if (Object.keys($scope.survey).length > 0) {
                        buildPageData();
                        $scope.PageStyle = $scope.survey.pages[$scope.survey.pages.length - 1].style;
                        $scope.loading = false;
                    }
                });
            }
        ])
    };
}
